export default __webpack_public_path__ + "static/media/misc-pantry3-768w.7d4e73a5.avif";